import { Box, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState, useMemo } from 'react';

const extractVideoId = (url) => {
    try {
        const parsed = new URL(url);
        if (parsed.hostname === 'youtu.be') {
            return parsed.pathname.replace('/', '');
        } else if (parsed.hostname.includes('youtube.com')) {
            return parsed.searchParams.get('v');
        }
    } catch (e) {
        console.warn('URL inválida:', url);
    }
    return null;
};

const YoutubePreviewContent = ({ url, width = '100%' }) => {
    const [loaded, setLoaded] = useState(false);

    const videoId = useMemo(() => extractVideoId(url), [url]);
    const thumbnail = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`; // calidad top pero no es la mejor
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&rel=0`;

    if (!videoId) return null;

    return (
        <Box
            position="relative"
            width={width}
            sx={{
                paddingTop: '56.25%', // 16:9 aspect ratio
                borderRadius: 2,
                overflow: 'hidden',
            }}
            className="youtube-preview-content"
        >
            {!loaded ? (
                <Box
                    component="img"
                    src={thumbnail}
                    alt="YouTube preview"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        cursor: 'pointer',
                    }}
                    onClick={() => setLoaded(true)}
                />
            ) : (
                <iframe
                    src={embedUrl}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 0,
                    }}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="YouTube video"
                />
            )}

            {!loaded && (
                <IconButton
                    onClick={() => setLoaded(true)}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.8)',
                        },
                    }}
                >
                    <PlayArrowIcon fontSize="large" />
                </IconButton>
            )}
        </Box>
    );
};

export default YoutubePreviewContent;
